import type { ReactNode } from "react";
import { cn } from "../../lib/utils";
import { useSetPageTitle } from "../../contexts/PageTitleContext";

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  className?: string;
  /** Titulo curto pro cabecalho fixo mobile (handoff: barra coral com voltar
   * + titulo). Cai pro `title` inteiro quando a tela nao precisa de versao
   * curta (a maioria — "curto" so importa quando o H1 e um nome de produto
   * ou tem "Frentes &amp; Canais" etc que nao cabe ao lado da seta voltar). */
  mobileTitle?: string;
}

export function PageHeader({ title, description, actions, breadcrumb, className, mobileTitle }: PageHeaderProps): JSX.Element {
  useSetPageTitle(mobileTitle ?? title);
  return (
    <div className={cn("page-header mb-2", className)}>
      {breadcrumb ? <div className="mb-2 field__hint">{breadcrumb}</div> : null}
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div className="page-header__intro min-w-0">
          <h1 className="page-title truncate">{title}</h1>
          {description ? <p className="page-desc">{description}</p> : null}
        </div>
        {actions ? <div className="page-header__actions flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
    </div>
  );
}
